export default __webpack_public_path__ + "static/media/signuphindi.173052c6.png";